import { Button, Content, CTABox, Spacer } from 'components';
import * as React from 'react';
export default {
  Button,
  Content,
  CTABox,
  Spacer,
  React
};